module.exports = __webpack_public_path__ + "img/Gruppenführer_Betreuungsgruppe.8df1372b.svg";